import * as React from 'react';
import { SVGProps } from 'react';

const IconMMPSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 13.825v2l1.667-.72a1 1 0 0 1 .798-.041l2.367.887a3 3 0 0 0 2.395-.126l1.39-.695a1 1 0 0 1 .842-.024l1.707.731a3 3 0 0 0 2.725-.184l.682-.41a1 1 0 0 1 .962-.037l.465.233v-2.196a3 3 0 0 0-2.456.285l-.682.41a1 1 0 0 1-.908.061l-1.708-.732a3 3 0 0 0-2.523.075l-1.39.695a1 1 0 0 1-.798.042l-2.367-.888a3 3 0 0 0-2.395.126L0 13.825ZM5 1h6v2h-.977l1.285 6H15v2H1V9h3.692l1.285-6H5V1Zm1.737 8h2.526L8.192 4h-.384L6.737 9Z"
    />
  </svg>
);
export default IconMMPSizeS;
